<template>
  <div>
    <b-card no-header>
      <form>
        <b-form-group
          label="Importe Cancelar"
          label-for="importe"
          :labelCols="labelCols">
          <b-form-input 
            id="importe"
            v-model.trim="$v.importe.$model"
            :state="importeValido"
            type="text"
            @blur.native="validate">
          </b-form-input>
          <b-form-invalid-feedback id="importeFeedback">
            {{ importeInvalidoMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>

        <b-form-group
          label="Observaciones"
          label-for="observaciones"
          :description="descripcion"
          :labelCols="labelCols">
          <b-form-textarea
            id="observaciones"
            v-model="$v.observaciones.$model" 
            rows="5"
            max-rows="5"
            :state="observacionesValidas"
            @blur.native="validate">
          </b-form-textarea>
          <b-form-invalid-feedback id="observacionesFeedback">
            {{ observacionesInvalidasMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>        
      </form>
      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="save">Grabar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="cancelar">Cancelar</b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import { required, decimal, maxLength } from 'vuelidate/lib/validators';

export default {
  name: 'Importe',
  props: {
    params: {
      type: Object,
      default: null,
    }
  },
  data () {
    return {
      importe: 0,
      observaciones: '',

      noValidar: true,
      importeValido: null,
      importeInvalidoMsj: '',
      observacionesValidas: null,
      observacionesInvalidasMsj: '',
      
      labelCols: 2,
    }
  },
  created() {
    this.importe = parseFloat(this.params.importe);
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();

            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }
      
      if (campo == 'importe' || validarTodos) {
        if (this.$v.importe.$error) {
          this.importeValido = false;
          if (!this.$v.importe.required) {
            this.importeInvalidoMsj = 'Debe ingresar el importe correspondiente';
          } else if (!this.$v.importe.decimal) {
            this.importeInvalidoMsj = 'El importe ingresado no es válido';
          }      
        } else {
          this.importeValido = null;
          this.importeInvalidoMsj = '';
        }
      }
      if (campo == 'observaciones' || validarTodos) {
        if (this.$v.observaciones.$error) {
          this.observacionesValidas = false;
          if (!this.$v.observaciones.maxLength) {
            this.observacionesInvalidasMsj = 'Las observaciones solo pueden contener hasta 5000 caracteres';
          }      
        } else {
          this.observacionesValidas = null;
          this.observacionesInvalidasMsj = '';
        }
      }      
    },
    save () {
      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        let params = {
          importe: this.importe,
          observaciones: this.observaciones,
        }
        this.$emit('save', params)
      }
    },
    cancelar() {
      this.$emit('close')
    },
  },
  validations: {
    importe: {
      required,
      decimal
    },
    observaciones: {
      maxLength: maxLength(5000)
    },
  },  
  watch: {
  }    
}
</script>

<style>
</style>
